const template = require('./en.html');
const fadeInSpeed = 150;
const fadeOutSpeed = 150;

let scriptPath: string;
let cookieBar: HTMLElement;
let button: HTMLElement;
let cookieInfo: HTMLElement;
let promptBtn: HTMLElement;
let promptClose: HTMLElement;
let promptContent: HTMLElement;
let interactionBlocker: HTMLElement;
let buttonSaveCustomized: HTMLElement;
let privacyLink: HTMLAnchorElement;
let mainBarPrivacyLink: HTMLAnchorElement;

let startup = false;
let shutup = false;

/**
 * Write cookieBar's cookie when user accepts cookies :)
 * @param {string} name - cookie name
 * @param {string} value - cookie value
 * @returns {void}
 */
const setCookie = (name: string, value: string) => {
    var exdays = 180;
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var cValue = encodeURI(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString() + ';path=/');
    document.cookie = name + '=' + cValue;
}

/**
 * Get Cookie Bar's cookie if available
 * @return {string} cookie value
 */
const getCookie = () => {
    var cookieValue = document.cookie.match(/(;)?cookiebar=([^;]*);?/);

    if (cookieValue == null) {
        return undefined;
    } else {
        return decodeURI(cookieValue[2]);
    }
}

/**
 * Remove all the cookies and empty localStorage when user refuses cookies
 * @returns {void}
 */
const removeCookies = () => {
    // Clear cookies
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c.replace(/^\ +/, '').replace(/\=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });

    // Clear localStorage
    if (localStorage !== null) {
        localStorage.clear();
    }
}

const detectLang = () => {
    return "en";
}

/**
 * Get ul parameter to look for
 * @param {string} name - param name
 * @return {String|Boolean} param value (false if parameter is not found)
 */
const getURLParameter = (name: string) => {
    console.log(scriptPath);
    var set = scriptPath.split(name + '=');
    if (set[1]) {
        return set[1].split(/[&?]+/)[0];
    } else {
        return "";
    }
}

const getScriptPath = () => {
    let scripts = document.getElementsByTagName('script');
    let path;

    for (let i = 0; i < scripts.length; i += 1) {
        if (scripts[i].hasAttribute('src')) {
            path = scripts[i].src;
            if (path.indexOf('cookiebar') > -1) {
                return path;
            }
        }
    }
    return "";
}


    /**
     * FadeIn effect
     * @param {HTMLElement} el - Element
     * @param {number} speed - effect duration
     * @returns {void}
     */
    const fadeIn = (el: HTMLElement, speed: number, display?: string) => {
        var d = typeof display === "undefined" ? 'block' : display;
        var s = el.style;
        s.opacity = "0";
        s.display = d;
        (function fade() {
            let o = parseFloat(s.opacity);
            o -= -0.1;
            s.opacity = o.toString();
            if (o <= 0.9) setTimeout(fade, (speed / 10));
        })();
    }


    /**
     * FadeOut effect
     * @param {HTMLElement} el - Element
     * @param {number} speed - effect duration
     * @returns {void}
     */
    const fadeOut = (el: HTMLElement, speed: number) => {
        console.log('fadeOut()');
        console.log(el);
        var s = el.style;
        s.opacity = "1";
        (function fade() {
            let o = parseFloat(s.opacity);
            o -= 0.1;
            s.opacity = o.toString();
            if (o >= 0) {
                setTimeout(fade, (speed / 10));
            } else {
                s.display = "none";
            }
            //(o -= 0.1) < 0.1 ? s.display = 'none' : setTimeout(fade, (speed / 10));
        })();
    }

/**
     * Load external files (css, language files etc.)
     * @returns {void}
     */
const startCookieBar = () => {

    // Load CSS file
    var path = scriptPath.replace(/[^\/]*$/, '');
    var stylesheet = document.createElement('link');
    stylesheet.setAttribute('rel', 'stylesheet');
    stylesheet.setAttribute('href', path + 'cookiebar.css');
    document.head.appendChild(stylesheet);

    // Create the html from the loaded template
    var element = document.createElement('div');
    element.innerHTML = template.default;
    document.getElementsByTagName('body')[0].appendChild(element);

    // Now we can assign references to DOM elements
    cookieBar = document.getElementById('cookie-bar')!;
    button = document.getElementById('cookie-bar-button')!;
    cookieInfo = document.getElementById('cookie-bar-prompt')!;
    promptBtn = document.getElementById('cookie-bar-prompt-button')!;
    promptClose = document.getElementById('cookie-bar-prompt-close')!;
    promptContent = document.getElementById('cookie-bar-prompt-content')!;
    interactionBlocker = document.getElementById('cookie-bar-interaction-blocker')!;
    buttonSaveCustomized = document.getElementById('cookiebar-save-customized')!;
    privacyLink = document.getElementById('cookie-bar-privacy-link') as HTMLAnchorElement;
    mainBarPrivacyLink = document.getElementById('cookie-bar-main-privacy-link') as HTMLAnchorElement;

    fadeIn(interactionBlocker, fadeInSpeed);

    cookieBar.style.bottom = "0";
    setBodyMargin('bottom');

    if (getURLParameter('privacyPage')) {
        privacyLink!.href = getPrivacyPageUrl();
    }

    if (getURLParameter('showPolicyLink') && getURLParameter('privacyPage')) {
        mainBarPrivacyLink.href = getPrivacyPageUrl();
        mainBarPrivacyLink.style.display = 'inline-block';
    }

    setEventListeners();
    fadeIn(cookieBar, fadeInSpeed, "flex");
}

const initCookieBar = () => {
    // If at least a cookie or localstorage is set, then STARTUP
    if (document.cookie.length > 0 || (window.localStorage !== null && window.localStorage.length > 0)) {
        var accepted = getCookie();
        if (accepted === undefined) {
            startup = true;
        } else {
            shutup = true;
        }
    } else {
        startup = false;
    }

    // If cookieBAR should always be show, then STARTUP
    if (getURLParameter('always')) {
        startup = true;
    }

    if (startup === true && shutup === false) {
        startCookieBar();
    }
}

const setupCookieBar = () => {
    scriptPath = getScriptPath();

    // Get the users current cookie selection
    var currentCookieSelection = getCookie();

    // If cookies are disallowed, delete all the cookies at every refresh
    if (currentCookieSelection == 'CookieDisallowed') {
        removeCookies();
        setCookie('cookiebar', 'CookieDisallowed');
    }

    // Stop further execution,
    // if the user already allowed / disallowed cookie usage.
    if (currentCookieSelection !== undefined) {
        return;
    }

    // init bar
    startup = true;
    initCookieBar();

}

/**
     * Get the privacy page's url (if set as an option)
     * @return {String} privacy page url
     */
const getPrivacyPageUrl = () => {
    return decodeURIComponent(getURLParameter('privacyPage'));
}



/**
 * Dispatch CustomEvent for an
 * easiest developer integration
 * @param {string} consent - Consent granted, customized or denied by the user
 * @returns {void}
 */
const dispatchCustomEvent = (consent: any) => {
    document.dispatchEvent(new CustomEvent('cookiebarConsent', {
        cancelable: true,
        detail: {
            consent: consent
        }
    }));
}






/**
 * Add a body tailored bottom (or top) margin so that CookieBar doesn't hide anything
 * @param {String} where Top or bottom margin
 * @returns {void}
 */
const setBodyMargin = (where: any) => {
    setTimeout(() => {

        var height = document.getElementById('cookie-bar') !.clientHeight;

        var bodyEl = document.getElementsByTagName('body')[0];
        var bodyStyle = window.getComputedStyle(bodyEl);

        switch (where) {
            case 'top':
                bodyEl.style.marginTop = (parseInt(bodyStyle.marginTop) + height) + 'px';
                break;
            case 'bottom':
                bodyEl.style.marginBottom = (parseInt(bodyStyle.marginBottom) + height) + 'px';
                break;
        }
    }, 300);
}





/**
 * Clear the bottom (or top) margin when the user closes the CookieBar
 * @returns {void}
 */
const clearBodyMargin = () => {
    var height = document.getElementById('cookie-bar') !.clientHeight;

    if (getURLParameter('top')) {
        var currentTop = parseInt(document.getElementsByTagName('body')[0].style.marginTop);
        document.getElementsByTagName('body')[0].style.marginTop = currentTop - height + 'px';
    } else {
        var currentBottom = parseInt(document.getElementsByTagName('body')[0].style.marginBottom);
        document.getElementsByTagName('body')[0].style.marginBottom = currentBottom - height + 'px';
    }
}


/**
 * Set button actions (event listeners)
 * @returns {void}
 */
const setEventListeners = () => {
    button.addEventListener('click', function () {
        setCookie('cookiebar', 'CookieAllowed');
        clearBodyMargin();
        fadeOut(cookieInfo, fadeOutSpeed);
        fadeOut(cookieBar, fadeOutSpeed);
        fadeOut(interactionBlocker, fadeOutSpeed);
        dispatchCustomEvent('CookieAllowed');
        if (getURLParameter('refreshPage')) {
            window.location.reload();
        }
    });

    buttonSaveCustomized.addEventListener('click', function () {
        var performanceCheckbox = document.getElementById('cookiebar-performance')! as HTMLInputElement;
        setCookie('cookiebar', 'CookieCustomized');
        setCookie('cookiebar-performance', performanceCheckbox.checked.toString());

        clearBodyMargin();
        fadeOut(cookieInfo, fadeOutSpeed);
        fadeOut(cookieBar, fadeOutSpeed);
        fadeOut(interactionBlocker, fadeOutSpeed);
        dispatchCustomEvent('CookieCustomized');
        if (getURLParameter('refreshPage')) {
            window.location.reload();
        }
    });

    promptBtn.addEventListener('click', function () {
        fadeIn(cookieInfo, fadeInSpeed, "flex");
    });

    promptClose.addEventListener('click', function () {
        //fadeOut(customize, 0);
        fadeOut(cookieInfo, fadeOutSpeed);
        //fadeOut(interactionBlocker, 250);
    });
}


// Load the script only if there is at least a cookie or a localStorage item
document.addEventListener('DOMContentLoaded', () => {
    setupCookieBar();
});